/* Fabric Alex — Izprati premium journey enhancer. Unpublished theme only. */
(function () {
  'use strict';

  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0056/5670/7118/files/fabric-alex-logo-email.png?v=1787502950';
  var MODAL_SELECTOR = '.octava-checkout-modal';
  var JOURNEY_SELECTOR = '[data-fa-izprati-journey="true"]';
  var STYLE_ID = 'fa-izprati-placement-v3-style';

  function isBulgarian() {
    return /^bg(?:-|$)/i.test(document.documentElement.getAttribute('lang') || '');
  }

  function copy() {
    if (isBulgarian()) {
      return {
        secure: 'Сигурно плащане',
        eyebrow: 'Завърши поръчката си',
        title: 'Завърши поръчката си в две стъпки',
        delivery: 'Контакт и доставка',
        deliveryMeta: 'Данни + адрес, офис или автомат',
        payment: 'Плащане',
        paymentMeta: 'Защитено плащане',
        start: 'Стъпка 1 от 2 · Въведи данните за контакт и избери доставка',
        editing: '',
        handoff: 'Стъпка 2 от 2 · Отваряме сигурното плащане',
        invoiceButton: 'Искам фактура',
        invoiceClose: 'Без фактура',
        invoiceTitle: 'Данни за фактура',
        invoiceCompany: 'Име на фирма',
        invoiceCompanyId: 'ЕИК',
        invoiceVat: 'ДДС номер (ако има)',
        invoicePerson: 'МОЛ',
        invoiceAddress: 'Адрес за фактура',
        invoiceNote: 'Данните ще бъдат добавени към поръчката.',
        phoneLabel: 'Обадете се',
        phoneHours: 'Всеки ден 09:00–22:00'
      };
    }

    return {
      secure: 'Secure checkout',
      eyebrow: 'Finish your order',
      title: 'Complete your order in two steps',
      delivery: 'Contact & delivery',
      deliveryMeta: 'Details + address, office or locker',
      payment: 'Payment',
      paymentMeta: 'Secure payment',
      start: 'Step 1 of 2 · Enter contact details and choose delivery',
      editing: '',
      handoff: 'Step 2 of 2 · Opening secure payment',
      invoiceButton: 'Want an invoice?',
      invoiceClose: 'No invoice',
      invoiceTitle: 'Invoice details',
      invoiceCompany: 'Company name',
      invoiceCompanyId: 'Company ID',
      invoiceVat: 'VAT number (optional)',
      invoicePerson: 'Contact person',
      invoiceAddress: 'Billing address',
      invoiceNote: 'These details will be added to your order.',
      phoneLabel: 'Call us',
      phoneHours: 'Every day 09:00–22:00'
    };
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  var INVOICE_ATTRS = {
    requested: 'Фактура',
    company: 'Фирма',
    companyId: 'ЕИК',
    vat: 'ДДС номер',
    person: 'МОЛ',
    address: 'Адрес за фактура'
  };

  function cartEndpoint(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + path.replace(/^\//, '');
  }

  function setInvoiceOpen(box, open, shouldSave) {
    if (!box) return;
    var panel = box.querySelector('[data-fa-invoice-panel]');
    var toggle = box.querySelector('[data-fa-invoice-toggle]');
    var c = copy();

    box.classList.toggle('is-open', !!open);
    if (panel) panel.hidden = !open;
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = toggle.querySelector('[data-fa-invoice-toggle-label]');
      if (label) label.textContent = open ? c.invoiceClose : c.invoiceButton;
    }

    if (shouldSave) persistInvoice(box, true);
  }

  function invoiceAttributes(box) {
    var attributes = {};
    var open = box && box.classList.contains('is-open');
    attributes[INVOICE_ATTRS.requested] = open ? 'Да' : '';

    Object.keys(INVOICE_ATTRS).forEach(function (key) {
      if (key === 'requested') return;
      var field = box && box.querySelector('[data-fa-invoice-field="' + key + '"]');
      attributes[INVOICE_ATTRS[key]] = open && field ? String(field.value || '').trim() : '';
    });

    return attributes;
  }

  function persistInvoice(box, immediate) {
    if (!box) return;
    if (box.__faInvoiceTimer) window.clearTimeout(box.__faInvoiceTimer);

    var send = function () {
      box.__faInvoiceTimer = null;
      fetch(cartEndpoint('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: invoiceAttributes(box) })
      }).catch(function () {});
    };

    if (immediate) send();
    else box.__faInvoiceTimer = window.setTimeout(send, 320);
  }

  function invoiceField(key, label, autocomplete, required) {
    var wrap = el('label', 'fa-izprati-invoice__field');
    var caption = el('span', '', label + (required ? ' *' : ''));
    var input = document.createElement('input');
    input.type = 'text';
    input.setAttribute('data-fa-invoice-field', key);
    input.setAttribute('autocomplete', autocomplete || 'off');
    input.setAttribute('aria-label', label);
    input.placeholder = label;
    input.required = !!required;
    wrap.appendChild(caption);
    wrap.appendChild(input);
    return wrap;
  }

  function hydrateInvoice(box) {
    if (!box || box.getAttribute('data-fa-invoice-hydrated') === 'true') return;
    box.setAttribute('data-fa-invoice-hydrated', 'true');

    fetch(cartEndpoint('cart.js'), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.attributes || !document.documentElement.contains(box)) return;
        var attrs = cart.attributes;
        Object.keys(INVOICE_ATTRS).forEach(function (key) {
          if (key === 'requested') return;
          var field = box.querySelector('[data-fa-invoice-field="' + key + '"]');
          if (field && attrs[INVOICE_ATTRS[key]]) field.value = attrs[INVOICE_ATTRS[key]];
        });
        if (attrs[INVOICE_ATTRS.requested] === 'Да') setInvoiceOpen(box, true, false);
      }).catch(function () {});
  }

  function buildInvoice() {
    var c = copy();
    var box = el('section', 'fa-izprati-invoice');
    box.setAttribute('data-fa-invoice', 'true');

    var toggle = el('button', 'fa-izprati-invoice__toggle');
    toggle.type = 'button';
    toggle.setAttribute('data-fa-invoice-toggle', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.appendChild(el('span', 'fa-izprati-invoice__icon', '▤'));
    var toggleLabel = el('span', '', c.invoiceButton);
    toggleLabel.setAttribute('data-fa-invoice-toggle-label', 'true');
    toggle.appendChild(toggleLabel);
    toggle.appendChild(el('span', 'fa-izprati-invoice__chevron', '＋'));
    box.appendChild(toggle);

    var panel = el('div', 'fa-izprati-invoice__panel');
    panel.setAttribute('data-fa-invoice-panel', 'true');
    panel.hidden = true;
    panel.appendChild(el('h3', 'fa-izprati-invoice__title', c.invoiceTitle));

    var form = el('div', 'fa-izprati-invoice__grid');
    form.setAttribute('data-fa-invoice-form', 'true');
    form.appendChild(invoiceField('company', c.invoiceCompany, 'organization', true));
    form.appendChild(invoiceField('companyId', c.invoiceCompanyId, 'off', true));
    form.appendChild(invoiceField('vat', c.invoiceVat, 'off', false));
    form.appendChild(invoiceField('person', c.invoicePerson, 'name', false));
    var address = invoiceField('address', c.invoiceAddress, 'street-address', true);
    address.classList.add('fa-izprati-invoice__field--wide');
    form.appendChild(address);
    panel.appendChild(form);
    panel.appendChild(el('p', 'fa-izprati-invoice__note', c.invoiceNote));
    box.appendChild(panel);

    toggle.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      setInvoiceOpen(box, open, true);
      if (open) {
        var first = box.querySelector('input');
        if (first) window.setTimeout(function () { first.focus(); }, 30);
      }
    });

    box.addEventListener('input', function () { persistInvoice(box, false); });
    box.addEventListener('change', function () { persistInvoice(box, true); });
    hydrateInvoice(box);
    return box;
  }

  function ensureInvoice(modal) {
    var contactSection = findContactSection(modal);
    if (!contactSection || !contactSection.parentElement) return null;

    var box = modal.querySelector('[data-fa-invoice="true"]');
    if (!box) box = buildInvoice();

    if (box.parentElement !== contactSection.parentElement || box.previousElementSibling !== contactSection) {
      contactSection.insertAdjacentElement('afterend', box);
    }
    return box;
  }

  function invoiceIsValid(modal) {
    var box = modal.querySelector('[data-fa-invoice="true"]');
    if (!box || !box.classList.contains('is-open')) return true;
    var fields = box.querySelectorAll('input[required]');
    for (var i = 0; i < fields.length; i += 1) {
      if (!fields[i].checkValidity()) {
        fields[i].reportValidity();
        fields[i].focus();
        return false;
      }
    }
    persistInvoice(box, true);
    return true;
  }

  function ensureHeaderPhone(modal, logo) {
    logo = logo || findExistingFabricAlexLogo(modal) || modal.querySelector('.fa-izprati-journey__logo');
    if (!logo || !logo.parentElement) return;

    var phone = modal.querySelector('[data-fa-izprati-phone="true"]');
    if (!phone) {
      phone = document.createElement('a');
      phone.className = 'fa-izprati-header-phone';
      phone.href = 'tel:+35952920123';
      phone.setAttribute('data-fa-izprati-phone', 'true');
      phone.innerHTML = '<span class="fa-izprati-header-phone__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.73a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.3 1.73.5 2.63.62A2 2 0 0 1 22 16.92z"></path></svg></span><span class="fa-izprati-header-phone__copy"><small data-fa-phone-label></small><strong>052 920 123</strong><small data-fa-phone-hours></small></span>';
    }

    var c = copy();
    var label = phone.querySelector('[data-fa-phone-label]');
    var hours = phone.querySelector('[data-fa-phone-hours]');
    if (label) label.textContent = c.phoneLabel;
    if (hours) hours.textContent = c.phoneHours;
    phone.setAttribute('aria-label', c.phoneLabel + ' 052 920 123. ' + c.phoneHours);

    if (phone.parentElement !== logo.parentElement || phone.previousElementSibling !== logo) {
      logo.insertAdjacentElement('afterend', phone);
    }
  }

  function installStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.octava-checkout-modal .fa-izprati-provider-badge{display:none!important;visibility:hidden!important;width:0!important;height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;}',
      '.octava-checkout-modal .octava-checkout-left.fa-izprati-stack-host{display:flex!important;flex-direction:column!important;align-items:stretch!important;gap:18px!important;min-width:0!important;}',
      '.octava-checkout-modal .fa-izprati-stack-host>.fa-izprati-journey{order:-100;width:100%!important;max-width:none!important;min-height:0!important;margin:0 0 2px!important;box-sizing:border-box!important;}',
      '.octava-checkout-modal .fa-izprati-stack-host>.octava-form-section{width:100%!important;max-width:none!important;margin:0!important;box-sizing:border-box!important;}',
      '.octava-checkout-modal .fa-izprati-journey--top{grid-column:1/-1!important;width:100%!important;max-width:none!important;min-height:0!important;}',
      '.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__meta{overflow:visible!important;text-overflow:clip!important;white-space:normal!important;}',
      '@media screen and (min-width:750px){.octava-checkout-modal .fa-izprati-journey--top{padding:15px 18px 14px!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-journey__headline{margin-bottom:11px!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress{grid-template-columns:minmax(0,1fr) 72px minmax(0,1fr)!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__step{padding:10px 12px!important}}',
      '@media screen and (max-width:749px){.octava-checkout-modal .octava-checkout-left.fa-izprati-stack-host{gap:14px!important}.octava-checkout-modal .fa-izprati-journey--top{margin:0!important;padding:13px 12px 12px!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress{grid-template-columns:minmax(0,1fr) 22px minmax(0,1fr)!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__step{grid-template-columns:29px minmax(0,1fr)!important;gap:6px!important;padding:7px 6px!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__number{width:29px!important;height:29px!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__label{font-size:10px!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-progress__meta{display:block!important;font-size:8px!important;line-height:1.15!important}.octava-checkout-modal .fa-izprati-journey--top .fa-izprati-journey__status{font-size:9px!important}}'
    ].join('');

    (document.head || document.documentElement).appendChild(style);
  }

  function findExistingFabricAlexLogo(modal) {
    var images = modal.querySelectorAll('img');
    var match = null;

    Array.prototype.some.call(images, function (img) {
      var signature = ((img.getAttribute('src') || '') + ' ' + (img.getAttribute('alt') || '')).toLowerCase();
      if (
        signature.indexOf('fabric-alex') !== -1 ||
        signature.indexOf('fabricalex') !== -1 ||
        signature.indexOf('fabric alex') !== -1 ||
        signature.indexOf('/1/0056/5670/7118/') !== -1
      ) {
        match = img;
        return true;
      }
      return false;
    });

    return match;
  }

  function buildStep(kind, number, label, meta) {
    var step = el('div', 'fa-izprati-progress__step fa-izprati-progress__step--' + kind);
    step.setAttribute('data-fa-izprati-step', kind);
    if (kind === 'delivery') step.setAttribute('aria-current', 'step');

    var badge = el('span', 'fa-izprati-progress__number', number);
    badge.setAttribute('data-fa-izprati-number', kind);
    step.appendChild(badge);

    var text = el('span', 'fa-izprati-progress__copy');
    var labelNode = el('strong', 'fa-izprati-progress__label', label);
    labelNode.setAttribute('data-fa-izprati-label', kind);
    var metaNode = el('span', 'fa-izprati-progress__meta', meta);
    metaNode.setAttribute('data-fa-izprati-meta', kind);
    text.appendChild(labelNode);
    text.appendChild(metaNode);
    step.appendChild(text);

    return step;
  }

  function buildJourney(showLogo) {
    var c = copy();
    var card = el('section', 'fa-izprati-journey fa-izprati-journey--top');
    card.setAttribute('data-fa-izprati-journey', 'true');
    card.setAttribute('aria-label', c.title);

    var brand = el('div', 'fa-izprati-journey__brand');
    if (showLogo) {
      var logo = document.createElement('img');
      logo.className = 'fa-izprati-journey__logo';
      logo.src = LOGO_URL;
      logo.alt = 'Fabric Alex';
      logo.loading = 'eager';
      logo.decoding = 'async';
      brand.appendChild(logo);
    } else {
      brand.appendChild(el('span', 'fa-izprati-journey__eyebrow', c.eyebrow));
    }
    brand.appendChild(el('span', 'fa-izprati-journey__secure', c.secure));
    card.appendChild(brand);

    var headline = el('div', 'fa-izprati-journey__headline');
    if (showLogo) headline.appendChild(el('span', 'fa-izprati-journey__eyebrow', c.eyebrow));
    var title = el('h2', 'fa-izprati-journey__title', c.title);
    title.setAttribute('data-fa-izprati-title', 'true');
    headline.appendChild(title);
    card.appendChild(headline);

    var progress = el('div', 'fa-izprati-progress');
    progress.appendChild(buildStep('delivery', '1', c.delivery, c.deliveryMeta));
    progress.appendChild(el('span', 'fa-izprati-progress__rail'));
    progress.appendChild(buildStep('payment', '2', c.payment, c.paymentMeta));
    card.appendChild(progress);

    return card;
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function checkoutFieldSignature(field) {
    return normalize([
      field.getAttribute('type'),
      field.getAttribute('name'),
      field.getAttribute('id'),
      field.getAttribute('placeholder'),
      field.getAttribute('autocomplete'),
      field.getAttribute('aria-label')
    ].join(' '));
  }

  function looksLikeContactField(field) {
    var signature = checkoutFieldSignature(field);
    return /(^|\s|[-_])(phone|tel|email|first.?name|last.?name|given.?name|family.?name)(\s|$|[-_])/.test(signature) ||
      signature.indexOf('телефон') !== -1 ||
      signature.indexOf('имейл') !== -1 ||
      signature.indexOf('e-mail') !== -1 ||
      signature.indexOf('собствено име') !== -1 ||
      signature.indexOf('фамилно име') !== -1;
  }

  function findContactSection(modal) {
    var scores = [];
    Array.prototype.forEach.call(modal.querySelectorAll('input,select,textarea'), function (field) {
      if (!looksLikeContactField(field)) return;
      var section = field.closest('.octava-form-section') ||
        field.closest('[class*="form-section"]') ||
        field.closest('[class*="section"]');
      if (!section) return;

      var item = null;
      Array.prototype.some.call(scores, function (entry) {
        if (entry.section === section) {
          item = entry;
          return true;
        }
        return false;
      });

      if (item) item.score += 1;
      else scores.push({ section: section, score: 1 });
    });

    scores.sort(function (a, b) { return b.score - a.score; });
    if (scores.length && scores[0].score >= 2) return scores[0].section;

    var fallback = null;
    Array.prototype.some.call(modal.querySelectorAll('.octava-form-section,[class*="form-section"]'), function (section) {
      var text = normalize(section.textContent);
      if (
        text.indexOf('contact') !== -1 ||
        text.indexOf('контакт') !== -1 ||
        text.indexOf('delivery details') !== -1 ||
        text.indexOf('данни за доставка') !== -1
      ) {
        fallback = section;
        return true;
      }
      return false;
    });
    return fallback;
  }

  function placeJourney(modal, journey) {
    if (!journey) return;
    journey.classList.add('fa-izprati-journey--top');

    var contactSection = findContactSection(modal);
    if (!contactSection || !contactSection.parentElement) return;

    var host = contactSection.parentElement;
    if (journey.parentElement !== host || journey.nextElementSibling !== contactSection) {
      host.insertBefore(journey, contactSection);
    }

    if (host.classList.contains('octava-checkout-left')) {
      host.classList.add('fa-izprati-stack-host');
    }
  }

  function hideProviderBranding(modal) {
    var candidates = [];

    Array.prototype.forEach.call(modal.querySelectorAll('div,span,p,a'), function (node) {
      var text = normalize(node.textContent);
      var hasPowered = text.indexOf('powered by') !== -1;
      var hasIzpratiText = text.indexOf('izprati') !== -1 || text.indexOf('изпрати') !== -1;
      var hasIzpratiImage = false;

      Array.prototype.some.call(node.querySelectorAll('img'), function (img) {
        var signature = normalize((img.getAttribute('src') || '') + ' ' + (img.getAttribute('alt') || ''));
        if (signature.indexOf('izprati') !== -1 || signature.indexOf('изпрати') !== -1) {
          hasIzpratiImage = true;
          return true;
        }
        return false;
      });

      if (hasPowered && (hasIzpratiText || hasIzpratiImage) && text.length < 120) {
        candidates.push(node);
      }
    });

    candidates.forEach(function (node) {
      var containsSmallerMatch = candidates.some(function (other) {
        return other !== node && node.contains(other);
      });
      if (!containsSmallerMatch) node.classList.add('fa-izprati-provider-badge');
    });

    Array.prototype.forEach.call(modal.querySelectorAll('img'), function (img) {
      var signature = normalize((img.getAttribute('src') || '') + ' ' + (img.getAttribute('alt') || ''));
      if (signature.indexOf('izprati') === -1 && signature.indexOf('изпрати') === -1) return;

      var parent = img.parentElement;
      for (var i = 0; parent && i < 3; i += 1, parent = parent.parentElement) {
        var parentText = normalize(parent.textContent);
        if (parentText.indexOf('powered by') !== -1) {
          parent.classList.add('fa-izprati-provider-badge');
          break;
        }
      }
    });
  }

  function refreshCopy(modal) {
    var journey = modal.querySelector(JOURNEY_SELECTOR);
    if (!journey) return;

    var c = copy();
    var title = journey.querySelector('[data-fa-izprati-title="true"]');
    var deliveryLabel = journey.querySelector('[data-fa-izprati-label="delivery"]');
    var deliveryMeta = journey.querySelector('[data-fa-izprati-meta="delivery"]');
    var paymentLabel = journey.querySelector('[data-fa-izprati-label="payment"]');
    var paymentMeta = journey.querySelector('[data-fa-izprati-meta="payment"]');
    var status = journey.querySelector('[data-fa-izprati-status="true"]');

    if (title) title.textContent = c.title;
    if (deliveryLabel) deliveryLabel.textContent = c.delivery;
    if (deliveryMeta) deliveryMeta.textContent = c.deliveryMeta;
    if (paymentLabel) paymentLabel.textContent = c.payment;
    if (paymentMeta) paymentMeta.textContent = c.paymentMeta;

    if (status) {
      if (journey.classList.contains('fa-izprati-journey--handoff')) status.textContent = c.handoff;
      else if (journey.classList.contains('fa-izprati-journey--editing')) status.textContent = c.editing;
      else status.textContent = c.start;
    }
  }

  function setState(modal, state) {
    var journey = modal.querySelector(JOURNEY_SELECTOR);
    if (!journey) return;

    var c = copy();
    var status = journey.querySelector('[data-fa-izprati-status="true"]');
    var deliveryNumber = journey.querySelector('[data-fa-izprati-number="delivery"]');
    var deliveryStep = journey.querySelector('[data-fa-izprati-step="delivery"]');
    var paymentStep = journey.querySelector('[data-fa-izprati-step="payment"]');

    journey.classList.remove('fa-izprati-journey--editing', 'fa-izprati-journey--handoff');

    if (state === 'handoff') {
      journey.classList.add('fa-izprati-journey--handoff');
      if (status) status.textContent = c.handoff;
      if (deliveryNumber) deliveryNumber.textContent = '✓';
      if (deliveryStep) deliveryStep.removeAttribute('aria-current');
      if (paymentStep) paymentStep.setAttribute('aria-current', 'step');
      return;
    }

    if (state === 'editing') {
      journey.classList.add('fa-izprati-journey--editing');
      if (status) status.textContent = c.editing;
    } else if (status) {
      status.textContent = c.start;
    }

    if (deliveryNumber) deliveryNumber.textContent = '1';
    if (deliveryStep) deliveryStep.setAttribute('aria-current', 'step');
    if (paymentStep) paymentStep.removeAttribute('aria-current');
  }

  function interactionTarget(target) {
    if (!target || target.nodeType !== 1) return false;
    return !!target.closest([
      '.octava-delivery-method-btn',
      '.octava-pickup-point',
      '.octava-service-point-item',
      '.octava-field input',
      '.octava-field select',
      '.octava-field textarea',
      '.octava-pickup-search',
      '.octava-near-me-button',
      'input[type="radio"]'
    ].join(','));
  }

  function bind(modal) {
    if (modal.getAttribute('data-fa-izprati-bound') === 'true') return;
    modal.setAttribute('data-fa-izprati-bound', 'true');

    modal.addEventListener('click', function (event) {
      var target = event.target && event.target.nodeType === 1 ? event.target : null;
      if (!target || target.closest(JOURNEY_SELECTOR)) return;

      var continueButton = target.closest('.octava-continue-btn');
      if (continueButton) {
        if (!invoiceIsValid(modal)) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }
        setState(modal, 'handoff');
        window.setTimeout(function () {
          if (document.documentElement.contains(modal)) setState(modal, 'editing');
        }, 1600);
        return;
      }

      if (interactionTarget(target)) setState(modal, 'editing');
    }, true);

    modal.addEventListener('change', function (event) {
      if (interactionTarget(event.target)) setState(modal, 'editing');
    }, true);

    modal.addEventListener('input', function (event) {
      if (interactionTarget(event.target)) setState(modal, 'editing');
    }, true);
  }

  function mount(modal) {
    if (!modal) return;

    var existingLogo = findExistingFabricAlexLogo(modal);
    if (existingLogo) existingLogo.classList.add('fa-izprati-existing-brand-logo');

    var journey = modal.querySelector(JOURNEY_SELECTOR);
    if (!journey) {
      var originalHost = modal.querySelector('.octava-checkout-left') ||
        modal.querySelector('.octava-checkout-body') ||
        modal.querySelector('.octava-checkout-modal-content');

      if (!originalHost) return;
      journey = buildJourney(!existingLogo);
      originalHost.insertBefore(journey, originalHost.firstChild);
    }

    placeJourney(modal, journey);
    hideProviderBranding(modal);
    refreshCopy(modal);
    ensureHeaderPhone(modal, existingLogo || journey.querySelector('.fa-izprati-journey__logo'));
    ensureInvoice(modal);
    bind(modal);
  }

  function scan() {
    installStyle();
    Array.prototype.forEach.call(document.querySelectorAll(MODAL_SELECTOR), mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(scan, 350);
  window.setTimeout(scan, 900);
  window.setTimeout(scan, 1800);
  window.setTimeout(scan, 3000);
})();
